import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./styles/muiRoot";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react"
import "quill/dist/quill.snow.css";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ErrorBoundary from "./services/utilities/errorHanding";
// import { SocketProvider } from "./socketContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <ThemeProvider theme={theme}>
    
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          {/* <SocketProvider> */}
          <App />
          {/* </SocketProvider> */}
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </ThemeProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
